<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :loading="loading"
        class="mt-5"
        height="auto"
        :error-message="errorMessage"
        @submit="updateCouponClaimValidDays({type: 'coupon_claim_valid_days',
         body: {'coupon_claim_valid_days': days},})"
    >
        {{ translations.description[lang] }}

        <b-text-field
            :label="translations.numberOfDays[lang]"
            type="number"
            v-model="days"
        ></b-text-field>
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/couponValidDays";
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";

export default {
    name: "CouponClaimValidDays",

    mixins: [translations],
  
    computed: {
        lang() {
            return this.$route.params.lang;
        },
        loading() {
            return this.$store.state.loyaltyPanel.businessProfile.loading.coupon_claim_valid_days;
        },

        errorMessage() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .coupon_claim_valid_days;
        },
        resetSuccess() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .coupon_claim_valid_days;
        },

        ...mapState("loyaltyPanel/businessProfile",["coupon_claim_valid_days"]),

         days: {
            get() {
                return this.coupon_claim_valid_days;
            },
            set(val) {
                this.setCouponClaimValidDays(val);
            },
        },

    },
    methods: {
        ...mapActions("loyaltyPanel/businessProfile", ["updateCouponClaimValidDays"]),
        ...mapMutations("loyaltyPanel/businessProfile", ["setCouponClaimValidDays"]),
    },

};
</script>
